import { Icon, Typo } from '@/ui/component/atom';
import { html, View } from 'rune-ts';
import klass from './Header.module.scss';

export interface HeaderData {
  title?: Typo;
}

export interface HeaderOption {
  back_button?: boolean;
  klass?: string;
  right_icon?: Icon;
}

export class Header extends View<HeaderData> {
  static HeaderBackEvent = class HeaderBackEvent extends CustomEvent<never> {};
  constructor(
    data: HeaderData,
    public option: HeaderOption = {},
  ) {
    super(data);
    this.option.back_button = this.option.back_button ?? true;
  }

  override template() {
    return html`<div class="${this.option.klass ?? ''} ${klass.header}">
      ${this.option.back_button
        ? html`<button type="button">${new Icon({ name: 'arrow_left', size: 24 })}</button>`
        : html`<div></div>`}
      ${this.data.title ? this.data.title : html`<div></div>`}
      <div>${this.option.right_icon ? this.option.right_icon : ''}</div>
    </div> `;
  }

  override onRender() {
    this.delegate('click', Icon, () => {
      this.dispatchEvent(Header.HeaderBackEvent, { bubbles: true });
    });
  }
}
